import { Components, Theme } from '@mui/material';

const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    colorPrimary: ({ theme }) => ({
      '&.Mui-checked .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
      '&.Mui-disabled .MuiSvgIcon-root': {
        color: theme.palette.action.disabled,
      },
    }),
  },
  variants: [
    {
      props: {
        size: 'small',
      },
      style: ({ theme }) => ({
        padding: theme.spacing(1),
      }),
    },
  ],
};

export default MuiCheckbox;
